import React, { useState } from 'react';
import {
  Table, TableHead, TableRow, TableCell, TableBody, Paper,
  Typography, Modal, Box, Stack, Button
} from '@mui/material';
import LinkClickChart from './LinkClickChart';
import axios from '../../utils/axios';
import config from '../../config';
// Thêm baseUrl vào props!
export default function TopLinksTable({ data = [], baseUrl }) {
  const [clickData, setClickData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Hàm lấy chi tiết click theo link id
  const fetchClickDetail = (linkId, from = null, to = null) => {
    const params = {};
    if (from && to) {
      params.from = from.toISOString();
      params.to = to.toISOString();
    }
    axios.get(`/statistics/link/${linkId}`, { params }).then(res => {
      setClickData(res.data.clickDetail || []);
    });
  };

  // Khi click 1 dòng
  const handleRowClick = (link) => {
    setSelectedLink(link);
    setClickData([]);
    setOpen(true);
    fetchClickDetail(link.id);
    setFromDate(null);
    setToDate(null);
  };

  // Filter nhanh theo khoảng thời gian
  const handleFilter = (rangeType) => {
    let from = null;
    let to = new Date();
    if (rangeType === '7days') {
      from = new Date(); from.setDate(to.getDate() - 7);
    } else if (rangeType === '30days') {
      from = new Date(); from.setDate(to.getDate() - 30);
    } else {
      from = null;
      to = null;
    }
    setFromDate(from);
    setToDate(to);
    if (selectedLink) {
      fetchClickDetail(selectedLink.id, from, to);
    }
  };

  return (
    <>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>🔥 Top 5 liên kết được click nhiều nhất</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Short URL</TableCell>
              <TableCell>Click</TableCell>
              <TableCell>User</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data && data.length > 0 ? data : []).slice(0, 5).map((link, idx) => (
              <TableRow
                key={link.id || link.short_code}
                hover
                style={{ cursor: 'pointer' }}
                onClick={() => handleRowClick(link)}
              >
                <TableCell>{idx + 1}</TableCell>
                <TableCell>
                  <a
                    href={`${baseUrl}/${link.short_code}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: "#1976d2", fontWeight: 600 }}
                    onClick={e => e.stopPropagation()} // Không mở modal khi click vào link
                  >
                    {link.short_code}
                  </a>
                </TableCell>
                <TableCell>{link.click_count || link.clicks || 0}</TableCell>
                <TableCell>{link.user_id || ''}</TableCell>
              </TableRow>
            ))}
            {(!data || data.length === 0) && (
              <TableRow>
                <TableCell colSpan={4} align="center" style={{ color: "#888" }}>
                  Không có dữ liệu
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{
          backgroundColor: '#fff', p: 4, borderRadius: 2, maxWidth: 800, mx: 'auto', mt: '10vh'
        }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Biểu đồ click theo ngày: {selectedLink?.short_code}
          </Typography>

          <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            <Button variant="outlined" onClick={() => handleFilter('7days')}>7 ngày</Button>
            <Button variant="outlined" onClick={() => handleFilter('30days')}>30 ngày</Button>
            <Button variant="outlined" onClick={() => handleFilter('all')}>Tất cả</Button>
          </Stack>

          <LinkClickChart data={clickData} />
        </Box>
      </Modal>
    </>
  );
}
